import { Box } from "@mui/material";
import React from "react";

export const Toolbar = ({ toolbarRef, children }) => {
  return (
    <Box
      ref={toolbarRef}
      sx={{
        mb: 1.5,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "nowrap",
          overflowX: "hidden",
          overflowY: "visible",
          pt: "5px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
export default Toolbar;
